// src/components/UpdateModal.js
import "./UpdateModal.css";

export default function UpdateModal({ onActualizar }) {
  return (
    <div className="update-overlay">
      <div className="update-modal">
        <div className="update-badge">Nueva versión</div>
        <h2 className="update-title">Hay una actualización disponible</h2>
        <p className="update-text">
          Caja POS se acaba de actualizar. Para seguir usando el sistema,
          debes recargar la página y cargar la nueva versión.
        </p>

        <ul className="update-list">
          <li>Se corrigen errores visuales y de funcionamiento.</li>
          <li>Tu sesión y datos se mantienen.</li>
          <li>La actualización toma sólo unos segundos.</li>
        </ul>

        <button className="update-btn" onClick={onActualizar}>
          Actualizar ahora
        </button>

        <p className="update-footnote">
          Este mensaje aparece cuando hay una nueva versión del sistema.
        </p>
      </div>
    </div>
  );
}
